/** Laufansicht „Kampagne gestartet“. */
const wizRunDE = {
  wizRunWorking: 'Agent am Arbeiten',
  wizRunDraftPill: 'Entwurf',
  wizRunDonePill: 'Agent ist fertig',
  wizRunPausedPill: 'Pausiert',
  wizRunPending: '{{count}} Nachrichten freigeben',
  wizRunNothing: 'Du musst nichts tun',
  wizRunPause: 'Pausieren',
  wizRunResume: 'Fortsetzen',
  wizRunToOverview: 'Zur Übersicht',
  wizRunWhatNow: 'Was jetzt passiert',
  wizRunApproveNow: 'Nachrichten jetzt freigeben',
  wizRunStatFound: 'Gefunden',
  wizRunStatFit: 'Passend',
  wizRunStatContacted: 'Kontaktiert',
  wizRunAgentTitle: 'So arbeitet der Agent',
  wizRunChange: 'Ändern',
  wizRunChangeCampaignTitle: 'Kriterien der Kampagne ändern',
  wizRunChangeCampaign: 'Kampagne ändern',
  wizRunLoading: 'Stand wird geladen …',
  wizRunLoadError: 'Der Stand der Kampagne konnte nicht geladen werden.',
  wizRunStatusError: 'Der Status konnte nicht geändert werden.',
};
export default wizRunDE;
